import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import {
  Layers,
  FiberManualRecord,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const cooperativeData = {
  title: "Répartition des collines/quartiers par province/commune selon les domaines d'intervention des coopératives",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", pasDeCoop: "-", agriculture: "45", elevage: "39", peche: "-", aquaculture: "1", foresterie: "2" },
        { name: "BUTIHINDA", pasDeCoop: "2", agriculture: "91", elevage: "79", peche: "2", aquaculture: "1", foresterie: "1" },
        { name: "CANKUZO", pasDeCoop: "-", agriculture: "37", elevage: "35", peche: "-", aquaculture: "-", foresterie: "7" },
        { name: "GISAGARA", pasDeCoop: "1", agriculture: "56", elevage: "54", peche: "-", aquaculture: "1", foresterie: "9" },
        { name: "GISURU", pasDeCoop: "2", agriculture: "82", elevage: "74", peche: "-", aquaculture: "-", foresterie: "1" },
        { name: "MUYINGA", pasDeCoop: "4", agriculture: "125", elevage: "125", peche: "-", aquaculture: "-", foresterie: "4" },
        { name: "RUYIGI", pasDeCoop: "-", agriculture: "53", elevage: "47", peche: "1", aquaculture: "1", foresterie: "2" }
      ],
      pasDeCoop: "9",
      agriculture: "489",
      elevage: "453",
      peche: "3",
      aquaculture: "4",
      foresterie: "26"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", pasDeCoop: "-", agriculture: "50", elevage: "41", peche: "1", aquaculture: "-", foresterie: "3" },
        { name: "BUKINANYANA", pasDeCoop: "3", agriculture: "43", elevage: "45", peche: "3", aquaculture: "-", foresterie: "4" },
        { name: "CIBITOKE", pasDeCoop: "-", agriculture: "34", elevage: "30", peche: "-", aquaculture: "3", foresterie: "4" },
        { name: "ISARE", pasDeCoop: "-", agriculture: "33", elevage: "38", peche: "-", aquaculture: "1", foresterie: "2" },
        { name: "MPANDA", pasDeCoop: "-", agriculture: "45", elevage: "37", peche: "4", aquaculture: "2", foresterie: "1" },
        { name: "MUGERE", pasDeCoop: "9", agriculture: "41", elevage: "37", peche: "3", aquaculture: "4", foresterie: "12" },
        { name: "MUGINA", pasDeCoop: "2", agriculture: "42", elevage: "42", peche: "1", aquaculture: "-", foresterie: "4" },
        { name: "MUHUTA", pasDeCoop: "-", agriculture: "36", elevage: "37", peche: "1", aquaculture: "1", foresterie: "2" },
        { name: "MUKAZA", pasDeCoop: "10", agriculture: "9", elevage: "11", peche: "-", aquaculture: "-", foresterie: "-" },
        { name: "NTAHANGWA", pasDeCoop: "20", agriculture: "60", elevage: "46", peche: "2", aquaculture: "3", foresterie: "4" },
        { name: "RWIBAGA", pasDeCoop: "1", agriculture: "41", elevage: "31", peche: "-", aquaculture: "-", foresterie: "-" }
      ],
      pasDeCoop: "45",
      agriculture: "434",
      elevage: "395",
      peche: "15",
      aquaculture: "14",
      foresterie: "36"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", pasDeCoop: "3", agriculture: "62", elevage: "55", peche: "-", aquaculture: "1", foresterie: "1" },
        { name: "MAKAMBA", pasDeCoop: "8", agriculture: "78", elevage: "76", peche: "-", aquaculture: "1", foresterie: "1" },
        { name: "MATANA", pasDeCoop: "3", agriculture: "57", elevage: "53", peche: "1", aquaculture: "-", foresterie: "-" },
        { name: "MUSONGATI", pasDeCoop: "1", agriculture: "88", elevage: "83", peche: "-", aquaculture: "1", foresterie: "3" },
        { name: "NYANZA", pasDeCoop: "12", agriculture: "66", elevage: "62", peche: "3", aquaculture: "1", foresterie: "-" },
        { name: "RUMONGE", pasDeCoop: "1", agriculture: "58", elevage: "56", peche: "3", aquaculture: "2", foresterie: "3" },
        { name: "RUTANA", pasDeCoop: "2", agriculture: "74", elevage: "69", peche: "1", aquaculture: "1", foresterie: "7" }
      ],
      pasDeCoop: "30",
      agriculture: "483",
      elevage: "454",
      peche: "8",
      aquaculture: "7",
      foresterie: "15"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", pasDeCoop: "4", agriculture: "78", elevage: "76", peche: "3", aquaculture: "1", foresterie: "4" },
        { name: "KAYANZA", pasDeCoop: "2", agriculture: "93", elevage: "103", peche: "-", aquaculture: "1", foresterie: "1" },
        { name: "KIREMBA", pasDeCoop: "2", agriculture: "97", elevage: "98", peche: "1", aquaculture: "1", foresterie: "1" },
        { name: "KIRUNDO", pasDeCoop: "19", agriculture: "114", elevage: "109", peche: "7", aquaculture: "4", foresterie: "4" },
        { name: "MATONGO", pasDeCoop: "1", agriculture: "76", elevage: "82", peche: "1", aquaculture: "1", foresterie: "5" },
        { name: "MUHANGA", pasDeCoop: "1", agriculture: "78", elevage: "78", peche: "1", aquaculture: "-", foresterie: "7" },
        { name: "NGOZI", pasDeCoop: "1", agriculture: "91", elevage: "82", peche: "2", aquaculture: "1", foresterie: "2" },
        { name: "TANGARA", pasDeCoop: "1", agriculture: "89", elevage: "86", peche: "1", aquaculture: "-", foresterie: "-" }
      ],
      pasDeCoop: "31",
      agriculture: "716",
      elevage: "714",
      peche: "16",
      aquaculture: "9",
      foresterie: "24"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", pasDeCoop: "1", agriculture: "38", elevage: "40", peche: "-", aquaculture: "1", foresterie: "4" },
        { name: "GISHUBI", pasDeCoop: "2", agriculture: "92", elevage: "82", peche: "1", aquaculture: "1", foresterie: "1" },
        { name: "GITEGA", pasDeCoop: "4", agriculture: "117", elevage: "111", peche: "1", aquaculture: "-", foresterie: "3" },
        { name: "KARUSI", pasDeCoop: "5", agriculture: "83", elevage: "86", peche: "-", aquaculture: "-", foresterie: "3" },
        { name: "KIGANDA", pasDeCoop: "2", agriculture: "46", elevage: "43", peche: "-", aquaculture: "-", foresterie: "1" },
        { name: "MURAMVYA", pasDeCoop: "-", agriculture: "42", elevage: "44", peche: "-", aquaculture: "1", foresterie: "2" },
        { name: "MWARO", pasDeCoop: "2", agriculture: "64", elevage: "49", peche: "1", aquaculture: "-", foresterie: "2" },
        { name: "NYABIHANGA", pasDeCoop: "-", agriculture: "69", elevage: "64", peche: "-", aquaculture: "-", foresterie: "-" },
        { name: "SHOMBO", pasDeCoop: "1", agriculture: "52", elevage: "59", peche: "-", aquaculture: "3", foresterie: "-" }
      ],
      pasDeCoop: "17",
      agriculture: "603",
      elevage: "578",
      peche: "3",
      aquaculture: "6",
      foresterie: "16"
    }
  ],
  total: {
    pasDeCoop: "132",
    agriculture: "2 725",
    elevage: "2 594",
    peche: "45",
    aquaculture: "40",
    foresterie: "117"
  }
};

const CooperativeInterventionPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province/Commune\tPas de coopératives\tAgriculture\tElevage\tPêche\tAquaculture\tForesterie\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${cooperativeData.total.pasDeCoop}\t${cooperativeData.total.agriculture}\t${cooperativeData.total.elevage}\t${cooperativeData.total.peche}\t${cooperativeData.total.aquaculture}\t${cooperativeData.total.foresterie}\n`;
    
    // Ajout des données par province et commune
    cooperativeData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.pasDeCoop}\t${province.agriculture}\t${province.elevage}\t${province.peche}\t${province.aquaculture}\t${province.foresterie}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.pasDeCoop}\t${commune.agriculture}\t${commune.elevage}\t${commune.peche}\t${commune.aquaculture}\t${commune.foresterie}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${cooperativeData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données des coopératives du Burundi: ${cooperativeData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(cooperativeData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `cooperatives-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  const filteredProvinces = cooperativeData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

  // Calcul des indicateurs clés
  const keyStats = {
    totalCoops: Object.values(cooperativeData.total).slice(1).reduce((sum, val) => sum + parseInt(val.toString().replace(/\s/g, '')) || 0, 0),
    mostCommonActivity: Object.entries(cooperativeData.total).slice(1).reduce((a, b) => a[1] > b[1] ? a : b)[0],
    provinceWithMostCoops: cooperativeData.provinces.reduce((max, province) => {
      const total = Object.values(province).slice(1).reduce((sum, val) => sum + parseInt(val.toString().replace(/\s/g, '')) || 0, 0);
      return total > max.total ? { name: province.name, total } : max;
    }, { name: '', total: 0 }),
    provinceWithLeastCoops: cooperativeData.provinces.reduce((min, province) => {
      const total = Object.values(province).slice(1).reduce((sum, val) => sum + parseInt(val.toString().replace(/\s/g, '')) || 0, 0);
      return total < min.total ? { name: province.name, total } : min;
    }, { name: '', total: Infinity })
  };

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {cooperativeData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Total coopératives
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.totalCoops.toLocaleString()}
                              </Typography>
                              <Typography variant="caption">
                                Tous domaines confondus
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Domaine principal
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.mostCommonActivity === 'agriculture' ? 'Agriculture' : 
                                 keyStats.mostCommonActivity === 'elevage' ? 'Élevage' :
                                 keyStats.mostCommonActivity === 'peche' ? 'Pêche' :
                                 keyStats.mostCommonActivity === 'aquaculture' ? 'Aquaculture' : 'Foresterie'}
                              </Typography>
                              <Typography variant="caption">
                                Activité la plus répandue
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus active
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithMostCoops.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithMostCoops.total.toLocaleString()} coopératives
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la moins active
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithLeastCoops.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithLeastCoops.total.toLocaleString()} coopératives
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données des coopératives">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Pas de coopératives</TableCell>
                          <TableCell align="right">Agriculture</TableCell>
                          <TableCell align="right">Elevage</TableCell>
                          <TableCell align="right">Pêche</TableCell>
                          <TableCell align="right">Aquaculture</TableCell>
                          <TableCell align="right">Foresterie</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.pasDeCoop}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.agriculture}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.elevage}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.peche}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.aquaculture}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{cooperativeData.total.foresterie}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.pasDeCoop}</TableCell>
                              <TableCell align="right">{province.agriculture}</TableCell>
                              <TableCell align="right">{province.elevage}</TableCell>
                              <TableCell align="right">{province.peche}</TableCell>
                              <TableCell align="right">{province.aquaculture}</TableCell>
                              <TableCell align="right">{province.foresterie}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={7}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.pasDeCoop}</TableCell>
                                          <TableCell align="right">{commune.agriculture}</TableCell>
                                          <TableCell align="right">{commune.elevage}</TableCell>
                                          <TableCell align="right">{commune.peche}</TableCell>
                                          <TableCell align="right">{commune.aquaculture}</TableCell>
                                          <TableCell align="right">{commune.foresterie}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                   */}
                </Paper>
                <Accordion sx={{ mb: 2 }}>
  <AccordionSummary expandIcon={<ExpandMore />}>
    <Typography variant="subtitle2" color="primary">
      Répartition géographique et sectorielle des coopératives
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
   

    <Grid container spacing={2}>
      {/* Top 5 provinces par nombre de coopératives */}
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" gutterBottom>
          Provinces les plus représentées (Top 5)
        </Typography>
        <List dense sx={{ py: 0 }}>
          {[...cooperativeData.provinces]
            .map(prov => ({
              name: prov.name,
              total: ['agriculture', 'elevage', 'peche', 'aquaculture', 'foresterie']
                .map(field => Number(prov[field] || 0))
                .reduce((a, b) => a + b, 0)
            }))
            .sort((a, b) => b.total - a.total)
            .slice(0, 5)
            .map((prov, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={`${index + 1}. ${prov.name}`}
                  secondary={`${prov.total} coopératives`}
                  secondaryTypographyProps={{ color: "text.secondary" }}
                />
              </ListItem>
            ))}
        </List>
      </Grid>

      {/* Répartition par secteur d'activité */}
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" gutterBottom>
          Principaux secteurs d'activité
        </Typography>
        <List dense sx={{ py: 0 }}>
          {[
            { 
              label: "Agriculture", 
              key: "agriculture", 
              details: "Cultures vivrières (banane, manioc), café, thé" 
            },
            { 
              label: "Élevage", 
              key: "elevage", 
              details: "Bovins, caprins, aviculture" 
            },
            { 
              label: "Pêche et aquaculture", 
              key: "peche", 
              details: "Pêche lacustre, pisciculture" 
            },
            { 
              label: "Artisanat", 
              key: "artisanat", 
              details: "Vannerie, poterie, tissage" 
            }
          ].map((sector, index) => {
            const totalCoops = cooperativeData.provinces.reduce(
              (acc, prov) => acc + Number(prov[sector.key] || 0),
              0
            );
            const totalAll = cooperativeData.provinces.reduce((acc, prov) => {
              return acc + ['agriculture', 'elevage', 'peche', 'aquaculture', 'foresterie']
                .map(k => Number(prov[k] || 0))
                .reduce((a, b) => a + b, 0);
            }, 0);
            const percent = totalAll > 0 ? ((totalCoops / totalAll) * 100).toFixed(1) : "0";

            return (
              <ListItem key={index}>
                <ListItemText
                  primary={`• ${sector.label} - ${percent}%`}
                  secondary={sector.details}
                  secondaryTypographyProps={{ color: "text.secondary" }}
                />
              </ListItem>
            );
          })}
        </List>
      </Grid>
    </Grid>

    <Typography variant="body2" mt={2} sx={{ fontStyle: 'italic' }}>
      Note : Les coopératives peuvent exercer plusieurs activités simultanément, ce qui explique que la somme des pourcentages peut dépasser 100%.
    </Typography>
  </AccordionDetails>
</Accordion>

{/* Encadré méthodologique */}
<Paper sx={{ 
  p: 2, 
  backgroundColor: theme => theme.palette.grey[100], 
  borderLeft: `4px solid ${theme.palette.secondary.main}`,
  mb: 3
}}>
  <Typography variant="subtitle2" gutterBottom color="primary">
    Méthodologie du recensement
  </Typography>
  
  <List dense>
    <ListItem sx={{ alignItems: 'flex-start' }}>
      <ListItemIcon sx={{ minWidth: 24, mt: 0.5 }}>
        <FiberManualRecord sx={{ fontSize: '0.8rem' }} />
      </ListItemIcon>
      <ListItemText 
        primary="Source officielle" 
        secondary="Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Élevage (RGPHAE 2024)" 
        secondaryTypographyProps={{ color: "text.secondary" }}
      />
    </ListItem>
    
    <ListItem sx={{ alignItems: 'flex-start' }}>
      <ListItemIcon sx={{ minWidth: 24, mt: 0.5 }}>
        <FiberManualRecord sx={{ fontSize: '0.8rem' }} />
      </ListItemIcon>
      <ListItemText 
        primary="Définition" 
        secondary="Une coopérative est un groupement d'au moins 5 personnes partageant des activités économiques communes avec une gestion démocratique" 
        secondaryTypographyProps={{ color: "text.secondary" }}
      />
    </ListItem>
  </List>
</Paper>
        </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default CooperativeInterventionPage;